import AbstractScene from './AbstractScene';
import ButtonText from '../prefabs/buttons/ButtonText';
import Answer from '../prefabs/quiz/Answer';
import { Colors } from '../consts/Colors';
import { Scales } from '../consts/Scales';
import { TextContents } from '../consts/TextContents.js';
import ButtonRounded from '../prefabs/buttons/ButtonRounded';
import RoundedContainer from '../prefabs/RoundedContainer.js';
import TraductionManager from '../prefabs/TraductionManager.js';

export default class Quiz extends AbstractScene {
    constructor() {
        super({
            key: 'Quiz',
        });
    }
    init(data) {
        this._init(data);
        this.traductionManager = new TraductionManager();
        this.textContents = TextContents;
        this.questionsList = this.game.data.quizContents;

        this.answers = [];
        this.selectedAnswers = [];
    }

    preload() {
        this._preload();
    }

    create() {
        this.game.data.firstScreen = false;
        this.background = this.add
            .image(0, 0, 'backMenu')
            .setOrigin(0)
            .setDisplaySize(this.width, this.height);
        this.backShadow = this.add
            .rectangle(0, 0, this.width, this.height, Colors.Elmt.DeepBlue, 0.9)
            .setOrigin(0);

        this.currentQuestion = this.questionsList[this.game.data.level];

        let quest = {
            text: this.traductionManager.getText(this.currentQuestion.question),
            config: {
                size:
                    this.game.data.langue === 'tha' || this.game.data.langue === 'jap'
                        ? 38 * this.game.data.scaleY + 'px'
                        : 56 * this.game.data.scaleY + 'px',
                fontFamily:
                    'MontserratItalic, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
                align: 'left',
                color: 'White',
                backColor: 'transparent',
                origin: { x: 0, y: 0 },
                width: 1000 * this.game.data.scaleX,
            },
        };

        this.leftContainer = this.add.container(
            this.game.data.langue === 'tha' || this.game.data.langue === 'jap'
                ? 100 * this.game.data.scaleX
                : 120 * this.game.data.scaleX,
            0,
        );
        this.question = this.createTextElement(
            this.game.data.langue === 'ara'
                ? this.width / 2 - 50
                : this.game.data.langue === 'tha' || this.game.data.langue === 'jap'
                  ? -10
                  : 0,
            20 * this.game.data.scaleX,
            quest,
        );
        this.leftContainer.add(this.question);

        // this.consigne = this.add
        //     .image(
        //         0,
        //         this.question.y + this.question.height + 30 * this.game.data.scaleX,
        //         consigneImg
        //     )
        //     .setOrigin(0);

        this.consigne = this.currentQuestion.isUnique
            ? this.add.existing(
                  new RoundedContainer(
                      this,
                      this.game.data.langue === 'ara' ? 550 : 0 + 180,
                      this.question.y + this.question.height + 60 * this.game.data.scaleX,
                      472 * this.game.data.scaleX,
                      89 * this.game.data.scaleY,
                      'icon_click',
                      this.traductionManager.getText('consigneQuiz'),
                      Colors.Elmt.LightBlue,
                  ),
              )
            : '';
        // .setScale(this.game.data.scaleX * 0.9);
        this.leftContainer.add(this.consigne);
        this.leftContainer.setSize(
            720 * this.game.data.scaleX,
            this.question.height + this.consigne.height + 30 * this.game.data.scaleY,
        );
        this.leftContainer.setY(this.height / 2 - this.leftContainer.height / 2);

        this.correction = this.createTextElement(
            this.game.data.langue === 'ara'
                ? 750
                : this.game.data.langue === 'tha' || this.game.data.langue === 'jap'
                  ? -10
                  : 0,
            this.question.y + this.question.height + 30 * 0.36,
            {
                text: this.traductionManager.getText(this.currentQuestion.correction),
                config: {
                    size:
                        this.game.data.langue === 'tha' || this.game.data.langue === 'jap'
                            ? 36 * this.game.data.scaleY + 'px'
                            : 42 * this.game.data.scaleY + 'px',
                    fontFamily:
                        'MontserratBold, "NotoSansJP-Bold", "NotoSansArabic-Bold", "NotoSansThai-Bold", sans-serif',
                    align: this.game.data.langue === 'ara' ? 'right' : 'left',
                    color: Colors.Text.ThirdBlue,
                    backColor: 'transparent',
                    origin: { x: this.game.data.langue === 'ara' ? 1 : 0, y: 0 },
                    width: 900 * this.game.data.scaleX,
                },
            },
        );
        this.leftContainer.add(this.correction);
        this.correction.setAlpha(0);

        const rightContainerWidth =
            this.game.data.langue === 'tha'
                ? 900 * this.game.data.scaleX
                : 720 * this.game.data.scaleX;
        const answerWidth = rightContainerWidth * 0.8; // 70%
        this.rightContainer = this.add.container(this.width * 0.75 - rightContainerWidth / 2, 0);
        let titleContent = 'Mauvaise réponse !';
        this.title = this.createTextElement(
            this.game.data.langue === 'ara'
                ? rightContainerWidth / 2 + 200
                : rightContainerWidth / 2,
            -20,
            {
                text: titleContent,
                config: {
                    size: 38 * this.game.data.scaleX + 'px',
                    fontFamily:
                        'MontserratSemiBold, "NotoSansJP-SemiBold", "NotoSansArabic-SemiBold", "NotoSansThai-SemiBold", sans-serif',
                    align: this.game.data.langue === 'ara' ? 'right' : 'center',
                    color: 'White',
                    backColor: 'transparent',
                    origin: { x: this.game.data.langue === 'ara' ? 1 : 0.5, y: 0 },
                    width: 1920 * this.game.data.scaleX,
                    wrap: {
                        mode: 'word', // 0|'none'|1|'word'|2|'char'|'character'
                        width: 1920 * this.game.data.scaleX,
                    },
                },
            },
        );
        this.rightContainer.add(this.title);
        this.rightContainerHeight = this.title.height + 80 * this.game.data.scaleY;
        this.title.setAlpha(0);
        this.allAnswers = this.currentQuestion.answers;

        if (this.currentQuestion.isMixed) {
            this.allAnswers = this.currentQuestion.answers.sort(() => 0.5 - Math.random());
        }

        const answerSpacing = 200 * this.game.data.scaleY;
        this.allAnswers.forEach((answer, i) => {
            if (this.allAnswers.length < 5) {
                this['answer' + i] = new Answer(
                    this,
                    rightContainerWidth / 2,
                    this.title.height + 80 * this.game.data.scaleY + i * answerSpacing,
                    answer,
                    true,
                    this.currentQuestion.isLarge,
                    answerWidth,
                );

                this.rightContainerHeight += 160 * this.game.data.scaleY;
            } else {
                if (i < 4) {
                    this['answer' + i] = new Answer(
                        this,
                        rightContainerWidth / 2,
                        this.title.height + 80 * this.game.data.scaleY + i * answerSpacing,
                        answer,
                        false,
                        this.currentQuestion.isLarge,
                    );
                    this.rightContainerHeight += 160 * 0.36;
                } else {
                    this['answer' + i] = new Answer(
                        this,
                        rightContainerWidth / 2,
                        this.title.height + 80 * this.game.data.scaleY + (i - 4) * answerSpacing,
                        answer,
                        false,
                        this.currentQuestion.isLarge,
                    );
                }
            }
            this.answers.push(this['answer' + i]);
            this.rightContainer.add(this['answer' + i]);
        });
        this.correctAnswersCount = this.answers.filter((answer) => answer.isTrue).length;
        this.rightContainerWidth = rightContainerWidth;

        this.lastAnswer = this.answers[this.answers.length - 1];
        this.lastAnswerBottomY = this.lastAnswer.y + this.lastAnswer.height / 2;
        this.lastAnswer = this.answers[this.answers.length - 1];
        this.lastAnswerBottomY = this.lastAnswer.y + this.lastAnswer.height / 2;

        this.validationBtn = this.add.existing(
            new ButtonRounded(
                this,
                rightContainerWidth / 2, // centré horizontalement
                this.lastAnswerBottomY + 80, // spacement vertical
                this.game.data.langue === 'esp' || this.game.data.langue === 'por'
                    ? 265 * 1.5 * this.game.data.scaleX
                    : 190 * 1.5 * this.game.data.scaleX,
                80 * 1.5 * this.game.data.scaleY,
                this.traductionManager.getText(TextContents.btnValiderQuiz.text),
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.Blue,
                true,
                this.game.data.langue === 'ara' ? 'arrow-left' : 'arrow-right',
                null,
            ),
        );
        this.rightContainer.add(this.validationBtn);
        // this.validationBtn.setLocked()
        // Centrer verticalement les éléments du rightContainer
        let totalHeight = this.validationBtn.y + this.validationBtn.height / 2;
        let verticalOffset = this.height / 2 - totalHeight / 2;

        // Appliquer un offset Y à tous les enfants
        this.rightContainer.iterate((child) => {
            child.y += verticalOffset;
        });

        this.rightContainer.setSize(
            700 * 0.44,
            this.rightContainerHeight + this.validationBtn.height + 30 * 0.36,
        );

        // this.validationBtn.setInteractive({ useHandCursor: true });
        this.validationBtn.on('pointerover', (e) => {
            this.validationBtn.setScale(1.05);
        });
        this.validationBtn.on('pointerout', (e) => {
            this.validationBtn.setScale(1);
        });
        this.validationBtn.on('pointerup', (e) => {
            if (this.isOneSelected()) {
                this.validationMecanic();
                this.answers.forEach((answer) => {
                    answer.disableInteractive();
                });
            }
        });
    }

    answerClicked(ans) {
        if (this.currentQuestion.isUnique) {
            this.answers.forEach((answer) => {
                if (answer !== ans) {
                    answer.setUnselected();
                }
            });
            ans.setSelected();
            this.selectedAnswers = [ans];
        } else {
            if (ans.isSelected) {
                ans.setUnselected();
                this.selectedAnswers = this.selectedAnswers.filter((answer) => answer !== ans);
            } else {
                ans.setSelected();
                this.selectedAnswers.push(ans);
            }
        }
        if (this.isOneSelected()) {
            this.setActiveBtn();
        }
    }

    changeValidationToNextBtn() {
        this.validationBtn.setText(
            this.traductionManager.getText(TextContents.btnSuivantQuiz.text),
        );
        this.validationBtn.off('pointerup');
        this.validationBtn.on('pointerup', () => {
            // Mécanique jeu classique
            this.validationBtn.disableInteractive();
            if (this.game.data.errorsCount >= 3) {
                console.log('game over');
                this.scene.start('GameOver');
            } else {
                this.scene.start('Game');
            }

            // // Mécanique version quiz complet
            // if (this.game.data.level >= this.questionsList.length) {
            //     this.scene.start('GameOver');
            // } else {
            //     // console.log('next question', this.game.data.level)
            //     this.scene.start('Quiz');
            // }
        });
    }

    addNextBtn() {
        // console.log('addNextBtn')

        // this.nextBtn = new ButtonText(this, 0, this.rightContainerHeight + 30, 'SUIVANT')
        // this.rightContainer.add(this.nextBtn)
        this.nextBtn = this.add.existing(
            new ButtonRounded(
                this,
                this.rightContainerWidth / 2, // Center horizontally in rightContainer
                this.lastAnswerBottomY + 80, // Position below answers
                190 * 1.5 * this.game.data.scaleX,
                80 * 1.5 * this.game.data.scaleY,
                TextContents.btnSuivantQuiz.text,
                Colors.Text.DarkBlue,
                Colors.Elmt.White,
                false,
                Colors.Text.Blue,
                true,
                'arrow-left',
                null,
            ),
        );
        this.rightContainer.add(this.nextBtn);
        this.nextBtn.setInteractive({ useHandCursor: true });
        this.nextBtn.on('pointerover', (e) => {
            this.nextBtn.setScale(1.05);
        });
        this.nextBtn.on('pointerout', (e) => {
            this.nextBtn.setScale(1);
        });
        this.nextBtn.on('pointerup', () => {
            this.nextBtn.destroy();
            if (this.game.data.errorsCount >= 3) {
                this.scene.start('GameOver');
                return;
            }
            this.scene.start('Game');

            // if (this.game.data.level >= this.questionsList.length) {
            //     this.scene.start("GameOver")
            // } else {
            //     // console.log('next question', this.game.data.level)
            //     this.scene.start("Quiz")
            // }
        });
    }

    addCorrection(status) {
        let titleContent = status
            ? this.traductionManager.getText(this.textContents.goodAnswer)
            : this.traductionManager.getText(this.textContents.wrongAnswer);
        // this.title = this.createTextElement(this.width / 2, 800, {
        //     text: titleContent,
        //     config: { size: '38px', fontFamily: 'Cardenio', align: 'center', color: 'Black', backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 1920 }
        // })
        this.title.setText(titleContent);
        this.title.setAlpha(1);
        this.correction.setAlpha(1);
        this.consigne.setAlpha(0);

        // this.correction = this.createTextElement(this.width / 2, 850, {
        //     text: this.currentQuestion.correction,
        //     config: { size: '38px', fontFamily: 'Cardenio', align: 'center', color: 'Black', backColor: 'transparent', origin: { x: 0.5, y: 0.5 }, width: 1920 }
        // })
    }

    isOneSelected() {
        return this.selectedAnswers.length > 0;
    }

    validationMecanic() {
        if (this.isOneSelected()) {
            this.game.data.level++;
            let correctSelectedCount = 0;
            this.answers.forEach((answer) => {
                if (answer.isTrue && answer.isSelected) {
                    answer.setTrue();
                    correctSelectedCount++;
                } else if (!answer.isTrue && answer.isSelected) {
                    answer.setFalse();
                } else if (answer.isTrue && !answer.isSelected) {
                    answer.setTrueForget();
                }
            });

            if (correctSelectedCount === this.correctAnswersCount) {
                this.addCorrection(true);
            } else {
                this.game.data.errorsCount++;
                this.addCorrection(false);
            }
            // this.validationBtn.destroy();
            this.changeValidationToNextBtn();
        }
    }

    setActiveBtn() {
        this.validationBtn.setInteractive({ useHandCursor: true });
    }
}
